const getDefaultState = () => ({
  activeTab: 0,
  domains: {
    items: [],
    itemsLoading: false,
    itemsError: false,
    domain: null,
  },
  suppliers: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    supplier: undefined,
  },
  cabins: {
    supplier: null,
    route: null,
    cabin: null,
    items: [],
    prices: {
      items: [],
      loading: false,
      error: null,
    },
    itemsLoading: false,
    itemsError: null,
    saveLoading: false,
    saveError: null,
    search: '',
  },
  extras: {
    supplier: null,
    route: null,
    extra: null,
    items: [],
    prices: {
      items: [],
      loading: false,
      error: null,
    },
    itemsLoading: false,
    itemsError: null,
    saveLoading: false,
    saveError: null,
    search: '',
  },
  carTypes: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    saveLoading: false,
    saveError: undefined,
    carType: undefined,
    search: '',
    supplier: undefined,
    pagination: {
      descending: false,
      page: 1,
      sortBy: 'name',
      rowsPerPage: 20,
      totalItems: 1,
    },
  },
  personCategories: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    saveLoading: false,
    saveError: undefined,
    personCategory: undefined,
    search: '',
    supplier: undefined,
    pagination: {
      descending: false,
      page: 1,
      sortBy: 'name',
      rowsPerPage: 20,
      totalItems: 1,
    },
  },
  routes: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    saveLoading: false,
    saveError: undefined,
    route: undefined,
    checkInInformations: {
      inbound: {
        address: '',
        zip: '',
        city: '',
        latestCheckInMinutesBeforeDeparture: 5,
        outbound: false,
      },
      outbound: {
        address: '',
        zip: '',
        city: '',
        latestCheckInMinutesBeforeDeparture: 5,
        outbound: true,
      },
    },
    texts: {
      items: [],
      tags: [],
      loading: false,
      error: false,
    },
    areas: [],
    areasLoading: false,
    areasError: undefined,
    sites: [],
    sitesLoading: false,
    sitesError: undefined,
    search: '',
    supplier: undefined,
    pagination: {
      descending: false,
      page: 1,
      sortBy: 'origin',
      rowsPerPage: 20,
      totalItems: 1,
    },
  },
  prices: {
    route: null,
    season: {
      items: [],
      loading: false,
      error: null,
      selected: null,
      selectedSeasonPrice: null,
      selectedDeparture: null,
      prices: {
        item: null,
        loading: false,
        error: null,
      },
    },
  },
  ferry: {
    route: null,
    season: {
      items: [],
      loading: false,
      error: null,
      selected: null,
      selectedSeasonPrice: null,
      prices: {
        item: null,
        loading: false,
        error: null,
      },
      days: {
        items: [],
        filteredItems: [],
        loading: false,
        error: false,
      },
    },
  },
  ferries: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    saveLoading: false,
    saveError: undefined,
  },
  departures: {
    items: [],
    loading: false,
    error: false,
    days: {
      items: [],
      filteredItems: [],
      loading: false,
      error: false,
    },
    extras: {
      items: [],
      prices: [],
      loading: false,
      error: false,
    },
    cabins: {
      items: [],
      prices: [],
      loading: false,
      error: false,
    },
    blockDays: {
      items: [],
      filteredItems: [],
      loading: false,
      error: null,
    },
  },
  newFerrySeasonPriceDay: {
    id: null,
    ferrySeasonPriceId: null,
    direction: 'outbound',
    availableAt: '',
  },
  departureBlockDays: {
    items: [],
    filteredItems: [],
    loading: false,
    error: null,
    saveLoading: false,
    saveError: undefined,
    selectedFerryId: null,
    new: {
      id: null,
      ferryId: null,
      blockedAt: '',
    },
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/transportation/defaultState.js